import { countBy, last } from 'lodash'
import { getBreadcrumbFromPermalink } from '@/../shared/utils/utils'

export default {
  computed: {
    isDynamicCategoryPage () {
      return !!this.categoryPermalink
    },
    categoryPermalink () {
      return this.$route.params.category
    },
    categoryDefaultFilters () {
      if (!this.isDynamicCategoryPage) return

      let categoryLvl = countBy(this.categoryPermalink, e => e === '/').true || 0
      let categoryValue = this.categoryPermalink.replace(/\//g, ' > ')

      return `category.lvl${categoryLvl}:"${categoryValue}"`
    },
    dynamicCategoryName () {
      let outdoor_category = (this.categoryPermalink.includes('outdoor/') && this.categoryPermalink.match(/outdoor/g).length == 1)  ? "Outdoor " : ""

      const permalinkLowestLevel = last((this.categoryPermalink || '').split('/'))
      const returned_category_name = outdoor_category + getBreadcrumbFromPermalink(permalinkLowestLevel)

      return returned_category_name
    }
  },
  methods: {
    // Replace first path component with "supplier" and remove all path components except first two.
    // E.g. /brands/supplier-name/category-1/category-2?k1=v1&k2=v2  ==>  /suppliers/supplier-name?k1=v1&k2=v2
    getApiPath (path) {
      if (this.isDynamicCategoryPage) path = path.replace(/^(\/[^/]+\/[^/?]+)(\/[^?]*)?(\?.*)?$/, '$1$3')

      return path.replace(/^\/brands\//, '/suppliers/')
    }
  }
}